import { AddressPermissions } from './addresses.permissions';
import { AddressRoles } from './addresses.roles';

export const addressMappings = {
  [AddressPermissions.UPDATE_ADDRESS]: [AddressRoles.MANAGER],
  [AddressPermissions.CREATE_ADDRESS]: [AddressRoles.MANAGER],
};
